var render = function () {
  var _vm$bookingPreset$nam, _vm$bookingPreset$nam2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('div', {
    staticClass: "overflow-auto w-100"
  }, [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": _vm.isBookingCenter() ? '' : 'BookingSelectList',
      "extra-items": _vm.isBookingCenter() ? ['登記預約中心', {
        text: (_vm$bookingPreset$nam = _vm.bookingPreset.name) !== null && _vm$bookingPreset$nam !== void 0 ? _vm$bookingPreset$nam : '',
        to: 'BookingCenterBookingList',
        params: _vm.$route.params.id
      }, '估價單'] : [{
        text: (_vm$bookingPreset$nam2 = _vm.bookingPreset.name) !== null && _vm$bookingPreset$nam2 !== void 0 ? _vm$bookingPreset$nam2 : '',
        to: 'BookingList',
        params: _vm.$route.params.id
      }, '估價單']
    }
  })], 1), _c('div', {
    staticClass: "col-12 d-flex justify-content-end"
  }, [_vm.checkPermission([_vm.consts.BOOKING_QUOTATION_TO_INVOICE]) ? _c('b-button', {
    staticClass: "col-1 mr-1",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": _vm.createInvoice
    }
  }, [_c('i', {
    staticClass: "fa fa-file-invoice-dollar"
  }), _vm._v(" 開立發票 ")]) : _vm._e(), _c('b-button', {
    staticClass: "col-1",
    attrs: {
      "variant": "inverse-info"
    },
    on: {
      "click": _vm.generatePdf
    }
  }, [_c('span', {
    staticClass: "mdi mdi-printer"
  }), _vm._v(" 列印 ")])], 1)]), _c('div', {
    staticClass: "pdf-container mx-auto",
    attrs: {
      "id": "download-pdf"
    }
  }, [_c('header', {
    staticClass: "my-4",
    domProps: {
      "innerHTML": _vm._s(_vm.getCleanedHtml(_vm.bookingPreset.config.quotation_header))
    }
  }), _c('h3', {
    staticClass: "quote-title",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }, [_vm._v("估價單")]), _c('p', {
    staticClass: "customer-info color-blue",
    domProps: {
      "innerHTML": _vm._s(_vm.subTitle)
    }
  }), _vm.isCompletedFormated ? _c('table', {
    staticClass: "quote-table"
  }, [_c('thead', [_c('tr', _vm._l(_vm.bookingPreset.config.quotation_content_header, function (header, index) {
    return _c('th', {
      key: 'header-' + index,
      style: header.style,
      attrs: {
        "colspan": header.colspan || 1
      },
      domProps: {
        "innerHTML": _vm._s(header.value && header.value.trim() ? header.value : header.text || '')
      }
    });
  }), 0)]), _c('tbody', [_vm._l(_vm.bookings, function (bookingFormatData, bookingIndex) {
    return _c('tr', {
      key: 'booking-' + bookingIndex
    }, _vm._l(_vm.getProcessedContent(bookingFormatData, _vm.bookingPreset.config.quotation_content, bookingIndex), function (content, index) {
      return _c('td', {
        key: 'content-' + bookingIndex + '-' + index,
        style: content.style ? _vm.parseStyle(content.style) : _vm.tdStyles[index],
        attrs: {
          "colspan": content.colspan || 1
        },
        domProps: {
          "innerHTML": _vm._s(content.value && content.value.trim() ? content.value : content.text || '')
        }
      });
    }), 0);
  }), _c('tr', _vm._l(_vm.getProcessedContent(_vm.bookings[0], _vm.bookingPreset.config.quotation_content_footer), function (footer, index) {
    return _c('td', {
      key: 'footer-' + index,
      style: footer.style,
      attrs: {
        "colspan": footer.colspan || 1
      },
      domProps: {
        "innerHTML": _vm._s(footer.value && footer.value.trim() ? footer.value : footer.text || '')
      }
    });
  }), 0)], 2)]) : _vm._e(), _c('footer', {
    domProps: {
      "innerHTML": _vm._s(_vm.getCleanedHtml(_vm.bookingPreset.config.quotation_footer))
    }
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }